import React from "react";

import { IHeaderProps } from "components/dashboard/product-template-table/utils/interfaces";
import { Tooltip } from "primereact/tooltip";

export default function Header(props: IHeaderProps) {
  // All messy code because tested <br/> tag in props.displayName
  const convertBr = (text: string) => {
    return text.replaceAll("<br/>", "\n");
  };

  const className = makeId(10);
  const targetClassName = `.${className}`;

  function makeId(length: number) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
    const charactersLength = characters.length;

    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }

    return result;
  }

  if (props.noTh) {
    return (
      <>
        <Tooltip target={targetClassName} mouseTrackLeft={10} />
        <div
          style={{ display: "flex", flexWrap: "nowrap", alignItems: "center", whiteSpace: "pre" }}
          className="change-padding"
        >
          {props.displayName && convertBr(props.displayName)}
          {props.description && (
            <span className={`${className} non-printable`} data-pr-tooltip={convertBr(props.description)}>
              <i className="pi pi-info-circle " style={{ fontSize: "12px", padding: "5px" }} />
            </span>
          )}
        </div>
      </>
    );
  }
  return (
    <th
      className="my-sticky-col data-cell custom-th my-th right-border header-class-for-print change-padding"
      style={{ display: "table-cell", whiteSpace: "pre" }}
    >
      <Tooltip target={targetClassName} mouseTrackLeft={10} />
      {props.displayName && convertBr(props.displayName)}
      {props.description && (
        <span className={`${className} non-printable`} data-pr-tooltip={convertBr(props.description)}>
          <i className="pi pi-info-circle" style={{ fontSize: "12px", padding: "5px" }} />
        </span>
      )}
    </th>
  );
}
